import React from 'react'
import { Link } from 'react-router-dom'
import logo from '../../images/logo/logo.png'
import { useLanguage } from '../../i18n'
import './style.scss'

const FooterArea = () => {
    const { t, language } = useLanguage();

    const footerLinks = [
        {
            titleKey: 'footer.quickLinks', menus: [
                { nameKey: 'nav.home', route: '#' },
                { nameKey: 'nav.practice', route: 'practice' },
                { nameKey: 'nav.team', route: 'team' },
                { nameKey: 'nav.blogs', route: 'blogs' },
            ]
        },
        {
            titleKey: 'footer.practiceAreas', menus: [
                { nameKey: 'Divorce', route: 'practice' },
                { name: language === 'hi' ? 'आपराधिक कानून' : 'Criminal Law', route: 'practice' },
                { name: language === 'hi' ? 'कॉर्पोरेट और वाणिज्यिक मुकदमेबाजी' : 'Corporate & Commercial Litigation', route: 'practice' },
                { name: language === 'hi' ? 'अनुबंध ड्राफ्टिंग' : 'Contract Drafting', route: 'practice' },
                { name: language === 'hi' ? 'रियल एस्टेट कानून' : 'Real Estate Law', route: 'practice' },
            ]
        },
        {
            titleKey: 'footer.contactUs', menus: [
                { nameKey: 'footer.headOffice' },
                { name: '40, Hanuman Lane, 2nd Floor, Baba Kharak Singh Marg, Connaught Place, New Delhi-110001', },
                { name: 'India', },
                { name: language === 'hi' ? 'फोन: +91-9555690946' : 'Phone: +91-9555690946', },
                { nameHTML: language === 'hi' ? 'ईमेल: contact@legalcorridors.com<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;legalcorridor@gmail.com' : 'Email: contact@legalcorridors.com<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;legalcorridor@gmail.com' },
            ]
        },
    ];

    return (
        <footer className="footerArea">
            <div className="footerTopArea">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-md-6 col-sm-6">
                            <div className="footerLogo">
                                <Link to="/">
                                    <img loading="lazy" decoding="async" src={logo} alt="Legal Corridor Logo" style={{ height: "80px", width: "320px" }} />
                                </Link>
                                <p>
                                    {language === 'hi'
                                        ? 'क्या आपको कोई समस्या है लेकिन किसी से परामर्श नहीं कर सकते? हमसे बात करें! हम वादा करते हैं कि हम आपकी मदद कर सकते हैं! अभी कॉल करें!'
                                        : <>Feeling stuck with a legal issue but unsure whom to trust?<br />Talk to us today — we’re here to guide you every step of the way.<br />📞 Call now for reliable legal assistance.<br /></>
                                    }
                                    <a href="tel:+919555690946" style={{ color: "yellow", display: "block" }}>+91-9555690946</a>
                                </p>
                            </div>
                        </div>
                        {footerLinks.map((menu, i) => (
                            <div key={i} className="col-lg-3 col-md-6 col-sm-6">
                                <div className="footerWrap">
                                    <h3>{t(menu.titleKey)}</h3>
                                    <ul>
                                        {menu.menus.map((item, j) => (
                                            <li key={j}>
                                                {item.route
                                                    ? <Link to={`/${item.route}`}>{item.nameKey ? t(item.nameKey) : item.name}</Link>
                                                    : item.nameHTML
                                                        ? <span dangerouslySetInnerHTML={{ __html: item.nameHTML }} />
                                                        : `${item.nameKey ? t(item.nameKey) : item.name}`
                                                }
                                            </li>
                                        ))}
                                    </ul>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            <div className="footerBottomArea">
                <div className="container">
                    <div className="footerBottomContent">
                        <div className="row">
                            <div className="col-md-8 col-sm-10 col-12">
                                <span>© 2024 Legal Corridors. {t('footer.allRightsReserved')} | {t('footer.returnPolicy')} | {t('footer.termsConditions')}</span>
                            </div>
                            <div className="col-md-4 col-sm-2 col-12">
                                <ul className="socialListFooter">
                                    <li>
                                        <Link to="https://www.instagram.com/amanverma_advocate?igsh=ODZ0MG0zY2s4c2U=&utm_source=ig_profile_share&igshid=1d14t1alv3d22">
                                            <i className="fa fa-instagram" aria-hidden="true"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.youtube.com/@Callyouradvocate">
                                            <i className="fa fa-youtube" aria-hidden="true"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.facebook.com/share/iXLSc6QPjvKstvvg/?mibextid=LQQJ4d">
                                            <i className="fa fa-facebook" aria-hidden="true"></i>
                                        </Link>
                                    </li>
                                    <li>
                                        <Link to="https://www.linkedin.com/in/adv-aman-verma-9986b2225">
                                            <i className="fa fa-linkedin" aria-hidden="true"></i>
                                        </Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    )
}
export default FooterArea